import { Flex } from '@mantine/core'
import { useTranslation } from 'next-i18next'
import BaseRiseColor from '@/components/BaseRiseColor'
import { FC } from 'react'
import { ArrowIconStyled, MarketListItemStyled } from './style'
import type { TopListItem } from 'api-price'
import { formatAddString } from '@/utils/tools'
import useLangPrefix from '@/hooks/useLangPrefix'
import { EnumNotableChangeTab } from '@/constants/index'

const MarketListItem: FC<TopListItem & { color: [string, string]; type: string }> = ({
  coin_short_name,
  dimension_24h,
  type,
  color,
}) => {
  const { t } = useTranslation()
  const isGainsState = !String(dimension_24h ?? '')?.includes('-')
  const { langPrefix } = useLangPrefix()
  return (
    <MarketListItemStyled {...{ component: 'li' }}>
      <Flex
        {...{
          component: 'a',
          href: `${langPrefix}/trade/${coin_short_name?.toLocaleUpperCase()}_USDT`,
          target: '_balnk',
        }}
        justify="space-between"
        align="center"
        className="price-coin-item"
      >
        <Flex gap={8} align="center">
          <ArrowIconStyled background={isGainsState ? color[0] : color[1]}>
            <svg className="iconpark-icon">
              <use href={`#v31-12px-fill-${isGainsState ? 'zhang' : 'die'}`}></use>
            </svg>
          </ArrowIconStyled>

          <span className="text-1 font-500 size-16">{coin_short_name}</span>
        </Flex>

        <Flex gap={8} align="center">
          <span className="text-3 font-400 size-14">
            {type === 'all' && t(`P.${EnumNotableChangeTab.ALL}`)}
            {type === 'fiveUp' && t(`P.${EnumNotableChangeTab.GAIN_5_MINS}`)}
            {type === 'fiveDown' && t(`P.${EnumNotableChangeTab.LOSS_5_MINS}`)}
            {type === 'hourUp' && t(`P.${EnumNotableChangeTab.HIGHEST_24H}`)}
            {type === 'hourDown' && t(`P.${EnumNotableChangeTab.LOWEST_24H}`)}
          </span>
          <BaseRiseColor value={Number(dimension_24h) > 0 ? 1 : -1}>
            <span className="font-500 size-14">{formatAddString(Number(dimension_24h) * 100)}</span>
          </BaseRiseColor>
        </Flex>
      </Flex>
    </MarketListItemStyled>
  )
}

export default MarketListItem
